/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import { Avatar, Typography, Box, Card, CardHeader, CardContent, IconButton } from '@mui/material';
import { styled } from '@mui/system';
import { Container } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EventList from '../Events/EventList';
import EventIcon from '@mui/icons-material/Event';
import AboutEvents from '../MoreEvents/AboutEvents';
import {Helmet} from "react-helmet";


const StyledTypography = styled(Typography)({
    textAlign: 'center',
    fontSize: '1.2rem',
    fontWeight: '600',
    marginTop: '1rem',
});

const StyledTypographyBio = styled(Typography)({
    textAlign: 'center',
    fontSize: '1rem',
    fontWeight: '400',
    marginTop: '0.5rem',
    marginBottom: '1rem',
});

const StyledCard = styled(Card)({
    boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.2)',
    borderRadius: '15px',
    padding: '2rem',
    marginTop: '0rem',
    backgroundColor: '#f2f2f2',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    marginBottom: '2rem'
});

const Events = () => {
    const { user, isAuthenticated } = useAuth0();
    const [petOwnerProfile, setPetOwnerProfile] = useState({
        name: '',
        bio: '',
        fileUrl: '',
    });
    const [aboutEventsOpen, setAboutEventsOpen] = useState(false);

    const handleAboutEvents = () => {
        //setCurrentPublicFigure(publicFigureDetails);
        setAboutEventsOpen(true);
    };

    useEffect(() => {
        const fetchPetOwnerProfile = async () => {
            if (isAuthenticated && user) {
                try {
                    const response = await fetch('/.netlify/functions/getPetOwnerProfile', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ userEmail: user.email }),
                    });

                    if (!response.ok) {
                        throw new Error(`HTTP error ${response.status}`);
                    }

                    const petOwnerProfileData = await response.json();

                    setPetOwnerProfile(petOwnerProfileData);
                } catch (error) {
                    console.error('Error fetching pet owner profile:', error);
                }
            }
        };

        fetchPetOwnerProfile();
    }, [user, isAuthenticated]);

    return (
        <Container maxWidth="md">
            <Helmet>
                <title>Wagzters - Events</title>
                <meta name="description" content="Wagzters - Discover and join upcoming pet-related events and competitions on Wagzters. From dog shows, pet adoption events to pet care webinars, find the perfect event for you and your pet."/>
                <meta property="og:title" content="Wagzters - Events" />
                <meta property="og:type" content="website" />
                <meta property="og:image" content="https://i.imgur.com/jrbqoWp.png" />
                <meta property="og:url" content="https://wagzters.com/events" />
                <meta property="og:description" content="Wagzters - Discover and join upcoming pet-related events and competitions on Wagzters. From dog shows, pet adoption events to pet care webinars, find the perfect event for you and your pet." />
            </Helmet>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    mt: 0
                }}>
                {isAuthenticated && user && (
                    <StyledCard>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                width: '100%',
                                padding: '0 1rem',
                            }}
                        >
                            <IconButton
                                style={{ visibility: 'hidden' }} // This is the "spacer" element.
                            >
                                <MoreVertIcon style={{ color: '#e91e63' }}/>
                            </IconButton>

                            <EventIcon
                                sx={{
                                    fontSize: 80,
                                    marginTop: '1rem',
                                    color:'#FFBF00'
                            }}
                            />

                            <IconButton onClick={() => handleAboutEvents()}>
                                <MoreVertIcon style={{ color: '#e91e63' }}/>
                            </IconButton>
                        </Box>

                        <CardContent>
                            <StyledTypography variant="h5" sx={{
                                color:'#333333'
                            }}>
                                {'Events' || ''}
                            </StyledTypography>
                            <StyledTypographyBio variant="body2" color="#9ca3af">
                                {'Browse Events'}
                            </StyledTypographyBio>
                        </CardContent>
                    </StyledCard>
                )}
                <EventList />
            </Box>
            {aboutEventsOpen && (
                <AboutEvents
                    open={aboutEventsOpen}
                    onClose={() => setAboutEventsOpen(false)}
                />
            )}
        </Container>
    );
};

export default Events;

